module.exports = __webpack_public_path__ + "img/fixed-1.36c7b7d2.png";